import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const GeneralTab = () => {
  return (
    <div className="space-y-6">
      {/* College Information */}
      <Card className="border-none shadow-sm">
        <CardHeader className="border-b border-gray-50 pb-3">
          <CardTitle className="text-lg font-bold">
            College Information
          </CardTitle>
          <p className="text-xs font-medium tracking-tight text-gray-500">
            Update your college basic information
          </p>
        </CardHeader>
        <CardContent className="space-y-4 pt-6">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="space-y-1.5">
              <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                College Name
              </Label>
              <Input
                defaultValue="ABC College of Engineering"
                className="border-gray-100 bg-gray-50/50 text-sm font-bold"
              />
            </div>
            <div className="space-y-1.5">
              <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                College Code
              </Label>
              <Input
                defaultValue="ABC123"
                className="border-gray-100 bg-gray-50/50 text-sm font-bold"
              />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
              Official Email
            </Label>
            <Input
              defaultValue="admin@college.edu"
              className="border-gray-100 bg-gray-50/50 text-sm font-bold"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
              Contact Number
            </Label>
            <Input
              defaultValue="+1-234-567-8900"
              className="border-gray-100 bg-gray-50/50 text-sm font-bold"
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
              Address
            </Label>
            <Input
              defaultValue="123 Education Street, City, State - 123456"
              className="border-gray-100 bg-gray-50/50 text-sm font-bold"
            />
          </div>
          <Button className="h-9 rounded-md bg-black px-6 text-xs font-bold text-white shadow-sm hover:bg-gray-800">
            Save Changes
          </Button>
        </CardContent>
      </Card>

      {/* Academic Year Settings */}
      <Card className="border-none shadow-sm">
        <CardHeader className="border-b border-gray-50 pb-3">
          <CardTitle className="text-lg font-bold">
            Academic Year Settings
          </CardTitle>
          <p className="text-xs font-medium tracking-tight text-gray-500">
            Configure current academic year and session
          </p>
        </CardHeader>
        <CardContent className="space-y-4 pt-6">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="space-y-1.5">
              <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                Current Academic Year
              </Label>
              <Input
                defaultValue="2024-2025"
                className="border-gray-100 bg-gray-50/50 text-sm font-bold"
              />
            </div>
            <div className="space-y-1.5">
              <Label className="text-[10px] font-bold uppercase tracking-widest text-gray-400">
                Current Semester
              </Label>
              <Input
                defaultValue="Spring 2025"
                className="border-gray-100 bg-gray-50/50 text-sm font-bold"
              />
            </div>
          </div>
          <Button className="h-9 rounded-md bg-black px-6 text-xs font-bold text-white shadow-sm hover:bg-gray-800">
            Update
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default GeneralTab;
